import {
  USER_LOGIN_FAILED,
  USER_LOGIN_REQ,
  USER_LOGIN_RESET,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT_REQ,
} from "../Constants/LoginConstant";
import api from "../Core/api";

export const LOGIN_PORTAL = (Login_data) => async (dispatch) => {
  const today = new Date();
  let time = today.getTime();
  try {
    dispatch({ type: USER_LOGIN_REQ });
    const { data } = await api.post("/users/login", Login_data);

    localStorage.setItem("accTkn", data?.accesstokenF);
    localStorage.setItem("UserDt", JSON.stringify(data?.Result[0]));
    localStorage.setItem("_bbExp", time);
    dispatch({ type: USER_LOGIN_SUCCESS, payload: { data, Time: time } });
  } catch (ex) {
    dispatch({
      type: USER_LOGIN_FAILED,
      payload: ex.response?.data?.Result
        ? ex.response?.data.Result
        : ex.message,
    });
  }
};

export const Logout = () => async (dispatch) => {
  localStorage.removeItem("accTkn");
  localStorage.removeItem("UserDt");
  dispatch({ type: USER_LOGOUT_REQ });
  //   REMOVE_LOCAL("_usInf");
  //   REMOVE_LOCAL("_bbExp");
};
export const LOGIN_FORM_RESET = () => (dispatch) => {
  dispatch({ type: USER_LOGIN_RESET });
};

export const Sidebar_Handle_Open = (data) => (dispatch) => {
  dispatch({ type: "SIDEBAR_OPEN", payload: data });
};


